import serviceProject from "../serviceProject";
import api from "../../../api";
import { createErrorMessage, createSuccessMessage } from "../../../service";

const RealignRecord = {
  ...serviceProject,
  resource: "raw-records",
  reprocess(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    let preList = this.getPreList("create", params);
    return api
      .post(`${preList ? "/" + preList : ""}/${this.resource}:realign`, params)
      .then(res => {
        createSuccessMessage("reprocess");
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  },
  testFilter(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    return api
      .post(`/${this.resource}:test-filter`, params)
      .then(res => {
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        errorHandler(res.response.data.errors);
        onError(res);
      });
  }
};
export default RealignRecord;
